import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import ChangePass from './changepass/ChangePass';


export default [
    <Route exact path="/configuration" component={Configuration} />,
    <Route exact path="/changepass" component={ChangePass} />,
    
];



// WEBPACK FOOTER //
// ./src/routes.js